import useBigPromo from "./useBigPromo.ts";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";

type PromoName = "big" | "apps" | "coachme";

export default function usePromoConfig() {
  const brand = useBrandLoaderData();

  const options: PromoName[] = [
    { key: "big" as const, enabled: !!useBigPromo() },
    {
      key: "apps" as const,
      enabled: brand.DownloadOffline.enabled && brand.DownloadOffline.qrEnabled,
    },
    { key: "coachme" as const, enabled: brand.CoachMe.enabled },
  ]
    .filter((el) => el.enabled)
    .map((el) => el.key);

  // Small promos look bad in a row by themselves
  if (options.length === 1 && options[0] !== "big") {
    return {
      mainRow: [],
      secondaryItem: options[0],
    };
  }

  return {
    mainRow: options.slice(0, 2),
    secondaryItem: options[2],
  };
}
